export const parseInspectionDateKey = (value) => {
  if (value == null || value === "") return null;

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return formatDateParts(
      value.getFullYear(),
      value.getMonth() + 1,
      value.getDate(),
    );
  }

  const str = String(value).trim();

  if (/^\d{4}-\d{2}-\d{2}/.test(str)) {
    return str.slice(0, 10);
  }

  const dashed = str.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
  if (dashed) {
    const partA = Number(dashed[1]);
    const partB = Number(dashed[2]);
    const year = dashed[3];

    if (partA > 12) {
      return formatDateParts(year, partB, partA);
    }
    if (partB > 12) {
      return formatDateParts(year, partA, partB);
    }
    return formatDateParts(year, partB, partA);
  }

  const slashed = str.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (slashed) {
    const partA = Number(slashed[1]);
    const partB = Number(slashed[2]);
    const year = slashed[3];

    if (partA > 12) {
      return formatDateParts(year, partB, partA);
    }
    if (partB > 12) {
      return formatDateParts(year, partA, partB);
    }
    return formatDateParts(year, partB, partA);
  }

  const parsed = new Date(str);
  if (!Number.isNaN(parsed.getTime())) {
    return formatDateParts(
      parsed.getFullYear(),
      parsed.getMonth() + 1,
      parsed.getDate(),
    );
  }

  return null;
};

const formatDateParts = (year, month, day) =>
  `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;

export const parseInspectionDate = (value) => {
  const key = parseInspectionDateKey(value);
  if (!key) return null;
  const [year, month, day] = key.split("-").map(Number);
  return new Date(year, month - 1, day);
};

export const formatInspectionHeadingDate = (value) => {
  const d = parseInspectionDate(value);
  if (!d) return value ? String(value) : "";
  return d.toLocaleDateString("en-AU", {
    weekday: "long",
    day: "numeric",
    month: "long",
  });
};

export const formatInspectionShortDate = (value) => {
  const d = parseInspectionDate(value);
  if (!d) return value ? String(value) : "";
  return d.toLocaleDateString("en-AU", {
    weekday: "short",
    day: "numeric",
    month: "short",
  });
};
